export default "__VITE_ASSET__DeaDAdO2__"